"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fragments_1 = require("../fragments");
const notifi_axios_utils_1 = require("@notifi-network/notifi-axios-utils");
const DEPENDENCIES = [...fragments_1.alertFragmentDependencies, fragments_1.alertFragment];
const MUTATION = `
query getAlerts {
  alert {
    ...alertFragment
  }
}
`.trim();
const getAlertsImpl = (0, notifi_axios_utils_1.makeParameterLessRequest)((0, notifi_axios_utils_1.collectDependencies)(...DEPENDENCIES, MUTATION), 'alert');
exports.default = getAlertsImpl;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0QWxlcnRzSW1wbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL2xpYi9xdWVyaWVzL2dldEFsZXJ0c0ltcGwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSw0Q0FBd0U7QUFDeEUsMkVBRzRDO0FBRzVDLE1BQU0sWUFBWSxHQUFHLENBQUMsR0FBRyxxQ0FBeUIsRUFBRSx5QkFBYSxDQUFDLENBQUM7QUFFbkUsTUFBTSxRQUFRLEdBQUc7Ozs7OztDQU1oQixDQUFDLElBQUksRUFBRSxDQUFDO0FBRVQsTUFBTSxhQUFhLEdBQUcsSUFBQSw2Q0FBd0IsRUFDNUMsSUFBQSx3Q0FBbUIsRUFBQyxHQUFHLFlBQVksRUFBRSxRQUFRLENBQUMsRUFDOUMsT0FBTyxDQUNSLENBQUM7QUFFRixrQkFBZSxhQUFhLENBQUMifQ==